const actions = {
  GET_TRIPLESEAT_LOCATION: 'GET_TRIPLESEAT_LOCATION',
  GET_TRIPLESEAT_LOCATION_REDUCER: 'GET_TRIPLESEAT_LOCATION_REDUCER',

  getLocation: () => ({ type: actions.GET_TRIPLESEAT_LOCATION }),
};

export default actions;
